import { Timestamp } from "../../firebase";

export const getFirebaseTimestampString = (timestamp) => {
  return new Timestamp(timestamp._seconds, 0).toDate().toLocaleString();
};
